import styled, { css } from 'styled-components';

import type { ThemeColor } from '../../styles/theme';

const PARAGRAPH_SIZE_VARIANTS = {
  '3xs': css`
    font-size: 0.45rem;
  `,
  '2xs': css`
    font-size: 0.625rem;
  `,
  xs: css`
    font-size: 0.75rem;
  `,
  sm: css`
    font-size: 0.875rem;
  `,
  md: css`
    font-size: 1rem;
  `,
  lg: css`
    font-size: 1.125rem;
  `,
  xl: css`
    font-size: 1.25rem;
  `,
  '2xl': css`
    font-size: 1.5rem;
  `,
} as const;

type ParagraphSizeVariant = keyof typeof PARAGRAPH_SIZE_VARIANTS;

const StyledParagraph = styled.p<{
  $sizeVariant: ParagraphSizeVariant;
  $colorVariant: ThemeColor;
  $weight: number;
  $textAlign?: 'left' | 'center' | 'right';
  $flexAlignCenter: boolean;
}>`
  color: ${(props) => props.theme.color[props.$colorVariant]};
  ${(props) => PARAGRAPH_SIZE_VARIANTS[props.$sizeVariant]}
  font-weight: ${(props) => props.$weight};
  line-height: 1.5;
  text-align: ${(props) => props.$textAlign};
  ${(props) => props.$flexAlignCenter && 'display: flex; align-items: center;'}
`;

export { StyledParagraph };
export type { ParagraphSizeVariant };
